import { Controller } from "@hotwired/stimulus"

const WHOLE_UNITS = ["piece", "set"]

// Adjusts quantity_on_hand step based on the selected unit.
export default class extends Controller {
    static targets = ["unitSelect", "quantityField"]

    connect() {
        this.updateStep()
    }

    updateStep() {
        const unit = this.unitSelectTarget.value
        const wholeUnit = WHOLE_UNITS.includes(unit)
        this.quantityFieldTarget.step = wholeUnit ? "1" : "0.001"
        this.quantityFieldTarget.min = "0"
    }
}